import { styled as muiStyled } from '@mui/material';
import Stack from '@mui/material/Stack';

export const CardWrapper = muiStyled(Stack)(() => ({
  padding: '24px 16px',
  borderRadius: '8px',
  flex: 1,
}));
